// story for site data

export default {
  title: 'Default Site Data',
  tags: ['autodocs'],
};

export const Default = {
  args: {
    siteData: {
      id: 2,
      organization_id: 1,
      alternate_ids: '2125138382',
      name: 'Majestic Sheep Orchard',
      alternate_names: 'MSO',
      address1: '9767 Hamill Place',
      address2: null,
      arrival: '2023-09-23',
      city: 'Janeanview',
      color: 'FF0000',
      contact_histories: {
        limit: 5,
        offset: 0,
        paginated_histories: [],
        total_count: 0,
        total_pages: 0,
      },
      contact_ids: [],
      contacts: [],
      coords_set_manually: true,
      county: 'Royal Village',
      created_at: '2024-07-05T12:35:59.636-04:00',
      custom_fields: [],
      departure: '2024-10-12',
      description: 'Brevity is the soul of wit.',
      directions: 'Proceed southeast from the cheerful "Entering Royal Village"',
      h2a: true,
      icon: null,
      latitude: 32.372457062786566,
      location_id: 2,
      longitude: -87.23564293721343,
      memo: 'thankful',
      notes: [],
      primary_contact_id: null,
      priority: 'no_priority',
      public: false,
      region: null,
      site_histories: {
        limit: 5,
        offset: 0,
        paginated_histories: [],
        total_count: 0,
        total_pages: 0,
      },
      site_images: [],
      site_type: 'Barracks',
      state: 'Alabama',
      status: 'active',
      tags: [],
      units: '62',
      updated_at: '2024-07-05T12:35:59.636-04:00',
      visits: [],
      worker_count: '14',
      zip_code: '04388-3304',
    },
  },
};

export const SiteWithData = {
  args: {
    siteData: {
      id: 2,
      organization_id: 1,
      alternate_ids: '2125138383',
      name: 'Majestic Sheep Orchard',
      alternate_names: 'MSO1',
      address1: '9767 Hamill Place',
      address2: null,
      arrival: '2023-09-23',
      city: 'Janeanview',
      color: 'FF0000',
      contact_histories: {
        limit: 5,
        offset: 0,
        paginated_histories: [
          {
            action: 'create',
            contact_changes: {
              contact_id: 86,
              contact_name: 'Aimee Hansen',
              site_id: 2,
              site_name: 'Majestic Sheep Orchard',
            },
            created_at: '2024-07-05T15:59:17.637-04:00',
            id: 41,
            user_id: 1,
            user_name: 'CTD Admin',
          },
        ],
        total_count: 1,
        total_pages: 1,
      },
      contact_ids: [86],
      contacts: [
        {
          address1: null,
          address2: null,
          city: null,
          client_unique_id: null,
          company: 'Bahringer, Konopelski and Littel',
          contact_type: 'School/Daycare',
          created_at: '2024-07-05T12:36:11.667-04:00',
          custom_fields: [],
          email: null,
          id: 86,
          name: 'Aimee Hansen',
          note: null,
          organization_id: 1,
          phone: '(307) 348-5279',
          state: null,
          updated_at: '2024-07-05T12:36:11.667-04:00',
          zip_code: null,
        },
      ],
      coords_set_manually: true,
      county: 'Royal Village',
      created_at: '2024-07-05T12:35:59.636-04:00',
      custom_fields: [],
      departure: '2024-10-12',
      description: 'Brevity is the soul of wit.',
      directions: 'Proceed southeast from the cheerful "Entering Royal Village"',
      h2a: true,
      icon: null,
      latitude: 32.372457062786566,
      location_id: 2,
      longitude: -87.23564293721343,
      memo: 'thankful',
      notes: [
        {
          author: 'Jane Doe',
          content: 'Lorem ipsum dolor sit amet',
          created_at: '2024-07-08T13:00:00.000-04:00',
          id: 50,
          priority: 'high',
          site_id: 2,
          site_name: 'Sunset Meadow',
          status: 'completed',
          timestamp: '2024-07-08',
          title: 'Site Visit',
          updated_at: '2024-07-08T13:00:00.000-04:00',
          user_id: 2,
        },
        {
          author: 'John Doe',
          content: 'Lorem ipsum dolor sit amet',
          created_at: '2024-03-08T13:00:00.000-04:00',
          id: 51,
          priority: 'low',
          site_id: 2,
          site_name: 'Sunset Meadow',
          status: 'completed',
          timestamp: '2024-03-08',
          title: 'Site Visit',
          updated_at: '2024-03-08T13:00:00.000-04:00',
          user_id: 2,
        },
        {
          author: 'Tom Doe',
          content: 'Lorem ipsum dolor sit amet',
          created_at: '2023-07-08T13:00:00.000-04:00',
          id: 52,
          priority: 'medium',
          site_id: 2,
          site_name: 'Sunset Meadow',
          status: 'completed',
          timestamp: '2023-07-08',
          title: 'Site Visit',
          updated_at: '2023-07-08T13:00:00.000-04:00',
          user_id: 2,
        },
        {
          author: 'Jane Doe',
          content: 'Lorem ipsum dolor sit amet',
          created_at: '2023-07-08T13:00:00.000-04:00',
          id: 53,
          priority: 'no_priority',
          site_id: 2,
          site_name: 'Sunset Meadow',
          status: 'completed',
          timestamp: '2023-07-08',
          title: 'Site Visit',
          updated_at: '2023-07-08T13:00:00.000-04:00',
          user_id: 2,
        },

      ],
      primary_contact_id: 86,
      priority: 'no_priority',
      public: false,
      region: null,
      site_histories: {
        limit: 5,
        offset: 0,
        paginated_histories: [
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 1,
            site_changes: {
              address2: { oldValue: '123', newValue: '' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 2,
            site_changes: {
              alternate_ids: { oldValue: '2125138382', newValue: '21251383' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 3,
            site_changes: {
              units: { oldValue: '62', newValue: '32' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 2,
            user_name: 'CTD Manager',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 4,
            site_changes: {
              zip_code: { oldValue: '80111', newValue: '' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 5,
            site_changes: {
              address1: { oldValue: '9767 Hamill Place', newValue: '' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 6,
            site_changes: {
              address2: { oldValue: '', newValue: '123' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 3,
            user_name: 'CTD User',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 7,
            site_changes: {
              alternate_ids: { oldValue: '2125138382', newValue: '21251383' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 8,
            site_changes: {
              units: { oldValue: '15', newValue: '62' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 3,
            user_name: 'CTD User',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 9,
            site_changes: {
              city: { oldValue: 'Denver', newValue: '' },

            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 10,
            site_changes: {
              phone: { oldValue: '(307) 348-5278', newValue: '(307) 348-5279' },
              name: { oldValue: 'Aimee', newValue: 'Aimee Hansen' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 1,
            user_name: 'CTD Admin',
          },
          {
            created_at: '2024-07-08T10:04:51.197-04:00',
            id: 12,
            site_changes: {
              phone: { oldValue: '(307) 348-5279', newValue: '(307) 348-5278' },
            },
            site_id: 2,
            updated_at: '2024-07-08T10:04:51.197-04:00',
            user_id: 3,
            user_name: 'CTD User',
          },
        ],
        total_count: 11,
        total_pages: 1,
      },
      site_images: [],
      site_type: 'Barracks',
      state: 'Alabama',
      status: 'active',
      tags: [
        {
          id: 3,
          organization_id: 1,
          name: 'Fredrick95007',
          status: 0,
          created_at: '2024-07-10T02:49:14.546-07:00',
          updated_at: '2024-07-10T02:49:14.546-07:00',
        },
        {
          id: 2,
          organization_id: 1,
          name: 'Blanche40023',
          status: 0,
          created_at: '2024-07-10T02:49:14.543-07:00',
          updated_at: '2024-07-10T02:49:14.543-07:00',
        },
      ],
      units: '62',
      updated_at: '2024-07-05T12:35:59.636-04:00',
      visits: [
        {
          completed: true,
          created_at: '2024-07-08T14:00:00.000-04:00',
          creator: 'John Smith',
          custom_fields: [
            { form_item_id: 9, position: 1, value: 'Visit Custom Value 1' },
          ],
          date: '2024-07-08',
          id: 60,
          leader: 'John Smith',
          needs_concerns: 'Bring extra water.',
          other_notes: 'Watch out for bees.',
          purpose: 'Inspection',
          routes_id: null,
          site_description: 'Beautiful and serene.',
          site_id: 2,
          site_name: 'Sunset Meadow',
          site_primary_image: { filename: 'sunset.jpg', url: 'https://example.com/sunset.jpg' },
          total_workers: 5,
          updated_at: '2024-07-08T14:00:00.000-04:00',
          user_id: 3,
          visitors: 'Group A',
          workers_interacted: 3,
        },
        {
          completed: false,
          created_at: '2024-07-08T14:00:00.000-04:00',
          creator: 'John Smith',
          custom_fields: [
            { form_item_id: 9, position: 1, value: 'Visit Custom Value 1' },
          ],
          date: '2024-07-08',
          id: 61,
          leader: 'John Smith',
          needs_concerns: 'Bring extra water.',
          other_notes: 'Watch out for bees.',
          purpose: 'Inspection',
          routes_id: null,
          site_description: 'Beautiful and serene.',
          site_id: 2,
          site_name: 'Sunset Meadow',
          site_primary_image: { filename: 'sunset.jpg', url: 'https://example.com/sunset.jpg' },
          total_workers: 5,
          updated_at: '2024-07-08T14:00:00.000-04:00',
          user_id: 3,
          visitors: 'Group A',
          workers_interacted: 10,
        },
      ],
      worker_count: '14',
      zip_code: '04388-3304',
    },
  },
};
